import React, { useContext, useEffect, useState } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import ThinFooter from "../Footer/ThinFooter";
import ContentWrapper from "../Atomics/ContentWrapper/ContentWrapper";
import { HeadingWrapper } from "../Atomics/SectionHeader/SectionHeader";
import { ProfileContext } from "../../context/profile";
import {
  campaignFetcher,
  channelFetcher,
  socialMediaFetcher,
} from "../../api/requests";
import { useToaster } from "../../context/toaster";
import { useParams, useLocation } from "react-router-dom";
import Spinner from "react-bootstrap/Spinner";
import { baseURL } from "../../api/dataFetcher";
import { error } from "jquery";

const ChannelEdit = () => {
  const { profile } = useContext(ProfileContext);
  const [channel, setChannel] = useState(null);

  const [formData, setFormData] = useState({
    name: "",
    description: "",
    avatar: null,
    banner: null,
    background: null,
    background_color: "",
    owner: "",
    Terms_participation_in_campaign: "",
    activation: false,
    scoring_formula: "",
  });

  const [previewAvatar, setPreviewAvatar] = useState(null);
  const [previewBanner, setPreviewBanner] = useState(null);
  const [previewBackground, setPreviewBackground] = useState(null);

  const { addMessage } = useToaster();
  const { id } = useParams();
  const [loading, setLoading] = useState(false);

  const location = useLocation();
  const campaignId = new URLSearchParams(location.search).get("campaign");
  const [socialMedia, setSocialMedia] = useState([
    { id: null, name: "", link: "", channel: id },
  ]);
  const [originalSocialMedia, setOriginalSocialMedia] = useState([]);
  const [socialId, setSocialId] = useState(null);

  const handleSocialMediaChange = (index, field, value) => {
    const updatedSocialMedia = socialMedia.map((entry, i) =>
      i === index ? { ...entry, [field]: value } : entry
    );
    setSocialMedia(updatedSocialMedia);
  };

  const handleAddSocialMedia = () => {
    setSocialMedia([
      ...socialMedia,
      { id: null, name: "", link: "", channel: id },
    ]);
  };

  const handleRemoveSocialMedia = (index) => {
    const updatedSocialMedia = socialMedia.filter((_, i) => i !== index);
    setSocialMedia(updatedSocialMedia);
  };

  // --------------------------------------------------
  // Load Channel / Campaign
  // --------------------------------------------------
  useEffect(() => {
    const getChannel = async () => {
      const fetched = campaignId
        ? await campaignFetcher.getEachCampaign(id)
        : await channelFetcher.getEachChannel(id);

      setChannel(fetched);

      if (fetched && profile.user) {
        setFormData({
          name: fetched.name || "",
          description: fetched.description || "",
          avatar: null,
          banner: null,
          background: null,
          background_color: fetched.background_color || "",
          owner: profile.user,
          Terms_participation_in_campaign:
            fetched.Terms_participation_in_campaign || "",
          activation: fetched.activation ?? false,
          scoring_formula: fetched.scoring_formula || "",
        });

        setPreviewAvatar(campaignId ? null : fetched.avatar || null);
        setPreviewBanner(fetched.banner || null);
        setPreviewBackground(campaignId ? fetched.background || null : null);
      }
    };

    const getSocialMedia = async () => {
      try {
        const data = await socialMediaFetcher.get(id);
        setSocialMedia(data.results.map((s) => ({ ...s, id: Number(s.id) })));
        setOriginalSocialMedia(
          data.results.map((s) => ({ ...s, id: Number(s.id) }))
        );
      } catch (err) {
        console.error("Error fetching social media data:", err);
      }
    };

    !campaignId && getSocialMedia();

    getChannel();
  }, [id, profile.user]);

  // --------------------------------------------------
  // Handlers
  // --------------------------------------------------
  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData((prev) => ({ ...prev, [id]: value }));
  };

  const fileReader = (file, setPreview, key) => {
    if (!file) return;
    const reader = new FileReader();
    reader.onloadend = () => setPreview(reader.result);
    reader.readAsDataURL(file);
    setFormData((prev) => ({ ...prev, [key]: file }));
  };

  const handleAvatarChange = (e) =>
    fileReader(
      e.target.files[0],
      campaignId ? setPreviewBackground : setPreviewAvatar,
      campaignId ? "background" : "avatar"
    );

  const handleBannerChange = (e) =>
    fileReader(e.target.files[0], setPreviewBanner, "banner");

  // --------------------------------------------------
  // Submit
  // --------------------------------------------------
  const showToast = (type, text) => {
    addMessage({
      id: Math.random().toString(36).substr(2, 9),
      type,
      text,
    });
  };

  const validateForm = () => {
    if (!formData.name) return showToast("error", "لطفا نام را وارد کنید.");
    if (!formData.description)
      return showToast("error", "لطفا توضیحات را وارد کنید.");
    return true;
  };

  const deleteSocial = async (id) => {
    try {
      if (id) await socialMediaFetcher.delete(id);

      showToast("success", "گزینه مورد نظر با موفقیت حذف شد.");
    } catch (err) {
      console.lerror(err);
      showToast("error", "حذف با مشکل مواجه شد، دوباره تلاش کنید.");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    setLoading(true);

    // --------------------------------------------------
    // SOCIAL MEDIA SYNC
    // --------------------------------------------------
    if (!campaignId) {
      const createList = socialMedia.filter(
        (s) => !s.id && (s.name.trim() !== "" || s.link.trim() !== "")
      );
      const updateList = socialMedia.filter((s) => Number(s.id));

      try {
        // CREATE
        for (let item of createList) {
          setSocialId(item?.id);
          const payload = {
            name: item.name,
            link: item.link,
            channel: id,
          };
          await socialMediaFetcher.post(payload);
        }

        // UPDATE
        for (let item of updateList) {
          setSocialId(item?.id);
          const payload = {
            name: item.name,
            link: item.link,
            channel: id,
          };
          await socialMediaFetcher.patch(item.id, payload);
        }

        setOriginalSocialMedia(socialMedia);
      } catch (err) {
        console.error("Social media sync failed:", err);
        showToast(
          "error",
          err?.response?.data?.detail
            ? err?.response?.data?.detail
            : "خطا در ویرایش شبکه‌های اجتماعی"
        );
      }
    }

    // --------------------------------------------------
    // CHANNEL / CAMPAIGN DESCRIPTION UPDATE
    // --------------------------------------------------
    try {
      const desc = new FormData();
      desc.append("name", formData.name);
      desc.append("description", formData.description);
      desc.append("owner", formData.owner);
      desc.append("activation", formData.activation);
      desc.append("background_color", formData.background_color);
      desc.append(
        "Terms_participation_in_campaign",
        formData.Terms_participation_in_campaign
      );
      desc.append("scoring_formula", formData.scoring_formula);

      const resDescription = campaignId
        ? await campaignFetcher.campaignDescriptionEdit(desc, id)
        : await channelFetcher.channelDescriptionEdit(desc, id);

      if (resDescription)
        showToast("success", "اطلاعات شما با موفقیت تغییر یافت.");

      // --------------------------------------------------
      // BACKGROUND DELETE (campaign only)
      // --------------------------------------------------
      if (
        campaignId &&
        formData.background === null &&
        previewBackground === null
      ) {
        const fd = new FormData();
        fd.append("background", "");
        await campaignFetcher.campaignBackgroundEdit(fd, id);
      }

      // --------------------------------------------------
      // BACKGROUND COLOR DELETE
      // --------------------------------------------------
      if (campaignId && formData.background_color === "") {
        const fd = new FormData();
        fd.append("background_color", "");
        await campaignFetcher.campaignDescriptionEdit(fd, id);
      }

      // --------------------------------------------------
      // UPLOAD BACKGROUND (campaign only)
      // --------------------------------------------------
      if (campaignId && formData.background instanceof File) {
        const bg = new FormData();
        bg.append("background", formData.background);

        const resBG = await campaignFetcher.campaignBackgroundEdit(bg, id);
        if (resBG) showToast("success", "پس زمینه با موفقیت تغییر یافت.");
      }

      // --------------------------------------------------
      // UPLOAD AVATAR (channel only)
      // --------------------------------------------------
      if (!campaignId && formData.avatar) {
        const avatar = new FormData();
        avatar.append("avatar", formData.avatar);
        const resAvatar = await channelFetcher.channelAvatarEdit(avatar, id);
        if (resAvatar) showToast("success", "آواتار با موفقیت تغییر یافت.");
      }

      // --------------------------------------------------
      // UPLOAD BANNER (both)
      // --------------------------------------------------
      if (formData.banner) {
        const banner = new FormData();
        banner.append("banner", formData.banner);

        const resBanner = campaignId
          ? await campaignFetcher.campaignBannerEdit(banner, id)
          : await channelFetcher.channelBannerEdit(banner, id);

        if (resBanner) showToast("success", "بنر با موفقیت تغییر یافت.");
      }
    } catch (err) {
      showToast(
        "error",
        err.response?.data?.message || "متاسفانه خطایی رخ داده است."
      );
    } finally {
      setLoading(false);
    }
  };

  // --------------------------------------------------
  // Reset form
  // --------------------------------------------------
  const handleCancelClick = () => {
    if (!channel) return;

    setFormData({
      name: channel.name || "",
      description: channel.description || "",
      avatar: null,
      banner: null,
      background: null,
      background_color: channel.background_color || "",
      Terms_participation_in_campaign:
        channel.Terms_participation_in_campaign || "",
      activation: channel.activation ?? false,
      scoring_formula: channel.scoring_formula || "",
      owner: profile.user,
    });

    setPreviewAvatar(channel.avatar || null);
    setPreviewBanner(channel.banner || null);
    setPreviewBackground(channel.background || null);
    setSocialMedia([{ name: "", link: "", channel: null }]);
  };

  const getImageSrc = (value) => {
    if (!value) return "/img/s1.png"; // nothing → fallback
    if (value.startsWith("data:")) return value; // base64
    return baseURL + value; // normal path
  };

  // --------------------------------------------------
  // Render
  // --------------------------------------------------
  return (
    <ContentWrapper>
      <Container
        fluid
        className="upload-details text-right"
        style={{ minHeight: "calc(100vh - 123px)" }}
      >
        <div style={{ padding: "30px" }}>
          <Row>
            <Col>
              <div className="float-right">
                <HeadingWrapper
                  heading={campaignId ? "ویرایش پویش" : "ویرایش کانال"}
                />
              </div>
            </Col>
          </Row>

          <Form onSubmit={handleSubmit}>
            {campaignId && (
              <Form.Row>
                <Form.Group as={Col} controlId="activation">
                  <Form.Label>وضعیت نمایش</Form.Label>
                  <Form.Check
                    type="checkbox"
                    checked={formData.activation}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        activation: e.target.checked,
                      })
                    }
                  />
                </Form.Group>
              </Form.Row>
            )}

            <Form.Row>
              <Form.Group as={Col} controlId="name">
                <Form.Label>نام</Form.Label>
                <Form.Control
                  type="text"
                  value={formData.name}
                  onChange={handleChange}
                />
              </Form.Group>

              <Form.Group as={Col} controlId="description">
                <Form.Label>توضیحات</Form.Label>
                <Form.Control
                  as="textarea"
                  value={formData.description}
                  onChange={handleChange}
                />
              </Form.Group>
            </Form.Row>

            {campaignId && (
              <Form.Row>
                <Form.Group
                  as={Col}
                  controlId="Terms_participation_in_campaign"
                >
                  <Form.Label>شعار</Form.Label>
                  <Form.Control
                    as="textarea"
                    value={formData.Terms_participation_in_campaign}
                    onChange={handleChange}
                  />
                </Form.Group>

                <Form.Group as={Col} controlId="scoring_formula">
                  <Form.Label>فرمول انتخاب برنده</Form.Label>
                  <Form.Control
                    as="textarea"
                    value={formData.scoring_formula}
                    onChange={handleChange}
                  />
                </Form.Group>
              </Form.Row>
            )}

            <Form.Row>
              {campaignId && (
                <Form.Group as={Col} controlId="background_color">
                  <Form.Label>رنگ پس زمینه</Form.Label>
                  <div className="d-flex align-items-center">
                    <Form.Control
                      type="color"
                      value={formData.background_color}
                      onChange={handleChange}
                      style={{
                        width: "60px",
                        height: "40px",
                        padding: 0,
                        border: "none",
                      }}
                    />

                    <Form.Control
                      type="text"
                      value={formData.background_color}
                      onChange={handleChange}
                      style={{ width: "100px", marginLeft: "10px" }}
                    />

                    <Button
                      variant="outline-danger"
                      size="sm"
                      className="ml-2"
                      onClick={() =>
                        setFormData((p) => ({ ...p, background_color: "" }))
                      }
                    >
                      لغو رنگ
                    </Button>
                  </div>
                </Form.Group>
              )}

              <Form.Group as={Col} controlId="avatar">
                <Form.Label>{campaignId ? "پس زمینه" : "آواتار"}</Form.Label>
                <div className="d-flex align-items-center">
                  <div
                    style={{
                      width: "50px",
                      height: "50px",
                      borderRadius: "50%",
                      overflow: "hidden",
                      marginLeft: "10px",
                    }}
                  >
                    <img
                      src={getImageSrc(previewBackground || previewAvatar)}
                      alt=""
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }}
                    />
                  </div>

                  <Form.Control type="file" onChange={handleAvatarChange} />

                  {campaignId && (
                    <Button
                      variant="outline-danger"
                      size="sm"
                      className="ml-2"
                      onClick={() => {
                        setFormData((p) => ({ ...p, background: null }));
                        setPreviewBackground(null);
                      }}
                    >
                      لغو
                    </Button>
                  )}
                </div>
              </Form.Group>

              <Form.Group as={Col} controlId="banner">
                <Form.Label>بنر</Form.Label>
                <div className="d-flex align-items-center">
                  <div
                    style={{
                      width: "50px",
                      height: "50px",
                      borderRadius: "50%",
                      overflow: "hidden",
                      marginLeft: "10px",
                    }}
                  >
                    <img
                      src={getImageSrc(previewBanner)}
                      alt=""
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }}
                    />
                  </div>

                  <Form.Control type="file" onChange={handleBannerChange} />
                </div>
              </Form.Group>
            </Form.Row>

            {!campaignId && (
              <Row style={{ marginBottom: "20px" }}>
                {socialMedia.map((entry, index) => (
                  <Col
                    lg={12}
                    key={index}
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    <Form.Group
                      className="ml-2"
                      controlId={`social-media-name-${index}`}
                    >
                      <Form.Label>نام شبکه اجتماعی</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="نام"
                        value={entry.name}
                        onChange={(e) =>
                          handleSocialMediaChange(index, "name", e.target.value)
                        }
                      />
                    </Form.Group>
                    <Form.Group
                      className="ml-2"
                      controlId={`social-media-link-${index}`}
                    >
                      <Form.Label>لینک</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="لینک"
                        value={entry.link}
                        onChange={(e) =>
                          handleSocialMediaChange(index, "link", e.target.value)
                        }
                      />
                    </Form.Group>
                    <Button
                      className="ml-2 mt-2"
                      style={{ fontSize: "12px" }}
                      variant="danger"
                      onClick={() => {
                        handleRemoveSocialMedia(index);
                        deleteSocial(entry?.id);
                      }}
                    >
                      &#215;
                    </Button>
                  </Col>
                ))}
                <Button
                  className="ml-2 mr-3"
                  style={{ fontSize: "12px" }}
                  variant="primary"
                  onClick={handleAddSocialMedia}
                >
                  افزودن شبکه اجتماعی
                </Button>
              </Row>
            )}

            <Row>
              <Col className="text-right">
                <Button
                  variant="danger"
                  className="mr-1"
                  onClick={handleCancelClick}
                >
                  لغو
                </Button>

                <Button
                  variant="success"
                  className="mr-1"
                  type="submit"
                  disabled={loading}
                >
                  {loading ? (
                    <>
                      <Spinner animation="border" size="sm" /> در حال
                      ذخیره‌سازی...
                    </>
                  ) : (
                    "ذخیره تغییرات"
                  )}
                </Button>
              </Col>
            </Row>
          </Form>
        </div>
      </Container>

      <ThinFooter />
    </ContentWrapper>
  );
};

export default ChannelEdit;
